import React from "react";
import styles from "./styles";
import {
  withStyles,
  CardContent,
  Collapse,
  Card,
  CardHeader,
  Avatar,
  IconButton,
} from "@material-ui/core";
import clsx from "clsx";
import {
  ExpandMore as ExpandMoreIcon,
  FilterNone as ResunaIcon,
  MoreVert,
  AttachMoney as DollarIcon
} from "@material-ui/icons";
import StopChangeSequence from "../../../../mapComponents/Markers/Dispatch/StopChangeSequence";
import CollapsibleDetails from "./CollapsibleDetails";
import ProcessDeliveryDialog from "./EditStopDialog";
import ProcessPickupStopDialog from "./PickupProcessing";
import RemoveProDialog from "./RemovePro/index";
import Tooltip from "../../../../common/StyledToolTip";
import CustomerMergeIndicator from "../../../../common/CustomerMergeIndicator";
import StyledToolTipWithScroll from "../../../../common/StyledToolTipWithScroll";
import appConstants from "../../../../../appConstants";
import {
  formatAddress,
  getPendingStopStatus,
  sortStopsBySequence,
  isShipmentsHasExcessiveLength,
  isDeliveryStopHasResunaPro,
  getPickupStopStatus,
  isStopHasCodShipments,
  getStopDeliveryStatusFromShipmentsDelCode,
  formatShipmentsStatusCodesForTooltip,
  getStatusLabelForCode,
} from "../../utils/utils";
import { SHOW_DRIVER_EVENTS, DRIVER_EVENTS } from "../constants";
import {
  isStopLocked,
  isStopLockedPermanently,
  shouldDisableActionForPreDispatch,
} from "./utils";
import { withSnackbar } from "notistack";
import { compose } from "recompose";
import { inject } from "mobx-react";
import { withAppConfig } from "../../../../../appConfigContext";
import StopActionMenu from "./StopActionMenu";
import RevisitStopConfirmationPopup from "./RevisitStopConfirmationPopup";
import constants from "./constants";
import { getStopArrivalTime, hasStopDelayed } from "../utils/index"
import StopSequenceHistory from "./StopSequenceHistory";
import { ExcessiveLength, UnarriveIndicator, RevisitIcon } from "../../icons";
import ProNotes from "./ProNotes";
import { UnacknowledgedMarker } from "../../../../mapComponents/Markers";
import GeofenceToolTip from "./GeofenceToolTip";
import { isPickupStopUnAcknowledged } from '@dataGrid/components/cellRenderer';
import StopCardTitle from "./common/StopCardTitle";
import { isUnattendedStop } from "../../../utils";
import dispatchPanelConstants from "../DispatchPanel/constants";
import { getDisplayServiceLevels } from "../../../shared/serviceLevelUtils";
const lockedText =
  "Locked - Do not allow resequencing when new stops are added to the route";
const unLockedText =
  "Unlocked - Allow resequencing when new stops are added to the route";

const tooltipStyles = () => ({
  tooltip: {
    width: 120 , 
    lineHeight: 1.5
  },
  tooltipPlacementBottom: {
    margin: 4
  }
});

const StyledGeofenceToolTip = withStyles(tooltipStyles)(Tooltip);
class Cards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: props.defaultExpanded,
      anchorEl: null,
      mutipleProData: [],
      action: null,
      showStopSequenceHistory: false,
      stopSequenceAnchorEl: null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.defaultExpanded != prevProps.defaultExpanded&& 
      this.state.expanded != this.props.defaultExpanded) {
      this.setState({
        expanded: this.props.defaultExpanded,
      });
    }
  }

  handleExpandClick = () => {
    this.setState((prevState) => {
      return {
        expanded: !prevState.expanded,
      };
    });
  };

  handleMenuChange = (action) => {
    if (action === constants.STOPS_MENU_ACTION_LIST.MARK_AS_NEXT_STOP) {
      this.markAsNextStop();
    }
    this.setState({
      action,
      anchorEl: null,
    });
  };

  handleMenuClose = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleMenuOpen = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      action: null,
    });
  };

  isPickupStop = () => {
    const { stopData } = this.props;
    return stopData.stopType === appConstants.STOP_TYPE.Pickup;
  };

  isStopCompleted = () => {
    const { stopData } = this.props;
    return stopData.isStopCompleted;
  };

  isCompletedReturnDelivery = () => {
    const { stopData } = this.props;
    if (!stopData.isStopCompleted || stopData.stopType !== appConstants.STOP_TYPE.Delivery || !stopData.shipments?.length) {
      return false;
    }
    return getStopDeliveryStatusFromShipmentsDelCode(stopData.shipments) === appConstants.DELIVERY_STATUS.RETURN;
  };

  isCardMenuExpandable = () => {
    const {
      enableAddNotesToPro,
      enableAddProToCompletedPro,
      resequenceMode,
      enableReprocessDelivery,
      enableRevisitDeliveryStop,
    } = this.props;
    const enableRevisitDeliveryOption = enableRevisitDeliveryStop && this.isCompletedReturnDelivery();
    if (enableAddNotesToPro || enableAddProToCompletedPro || enableReprocessDelivery || enableRevisitDeliveryOption) {
      return !resequenceMode;
    }
    return !this.isStopCompleted() && !resequenceMode;
  };

  isNextStop = () => {
    const { stopData, routeData } = this.props;
    const { currentStatus } = routeData;
    const sortedStopList = sortStopsBySequence(routeData.stops);

    // check if route has arrived stop and current stop is next to it
    if (
      currentStatus?.stopId &&
      currentStatus?.status === DRIVER_EVENTS.ArrivedAtStop
    ) {
      const arrivedStop = sortedStopList.find(
        (stop) => stop.stopId === currentStatus.stopId
      );
      if(arrivedStop){
        return stopData.stopSequence === arrivedStop.stopSequence + 1;
      }
    }

    // check if current stop is first stop that is not completed yet
    const firstIncompleteStop = sortedStopList.find(
      (stop) => !stop.isStopCompleted
    );
    return firstIncompleteStop.stopId === stopData.stopId;
  };

  isDriverArrivedAtCurrentStop = () => {
    return this.props.isDriverCurrentStop && this.isDriverArrivedAtStop();
  };

  isMarkAsNextStopEnabled = () => {
    return (
      !this.isStopCompleted() &&
      !this.isNextStop() &&
      !this.isDriverArrivedAtCurrentStop()
    );
  };

  getUniqueShipmentDeliveryCodes = () => {
    const {
      stopData: { shipments },
    } = this.props;
    return [
      ...new Set(shipments.map((shipment) => shipment.returnCode)),
      ...new Set(shipments.flatMap((shipment) => shipment.exceptionCode)), //exception code is an array
    ].filter((data) => data);
  };

  populateCompletedDeliveryStopStatus = () => {
    const {
      stopData: { shipments },
      DispatchStore,
      configJSON,
    } = this.props;
    const overallStopStatus = getStopDeliveryStatusFromShipmentsDelCode(shipments);
    const statusCodes = this.getUniqueShipmentDeliveryCodes();
    const combinedStopStatusCodes = statusCodes.length > 0 ? statusCodes.join(', ') : '';
    const hasReturnOrException = statusCodes.length > 0;
    const enableReturnExceptionReasonLabels = Boolean(
      configJSON?.enableReturnExceptionReasonLabels
    );

    // When flag is on, resolve labels for any stop that has return/exception codes — not only
    // when overallStopStatus is Return / Delivery Exception.
    if (enableReturnExceptionReasonLabels && hasReturnOrException) {
      const labels = statusCodes
        .map((code) => getStatusLabelForCode(code, DispatchStore))
        .filter(Boolean);
      if (labels.length > 0) {
        return {
          overallStopStatus: `${overallStopStatus} (${labels.join(', ')})`,
          stopStatusCode: "",
          hasReturnOrExceptionBill: true,
        };
      }
    }

    return {
      overallStopStatus,
      stopStatusCode: combinedStopStatusCodes,
      hasReturnOrExceptionBill: hasReturnOrException,
    };
  };

  populatePickupStopStatus = () => {
    const { stopData, enableNoFreightCode, DispatchStore, configJSON } = this.props;
    return {
      overallStopStatus: getPickupStopStatus({
        stop: stopData,
        enableNoFreightCode,
        noFreightReasonCodeList: DispatchStore?.staticClientData?.clientCodes?.noFreightCode,
        enableReturnExceptionReasonLabels: configJSON?.enableReturnExceptionReasonLabels,
      }),
      stopStatusCode: "",
      hasReturnOrExceptionBill: false,
    };
  };

  getStopStatus = () => {
    const {
      stopData,
    } = this.props;
    if (!this.isStopCompleted()) {
      return getPendingStopStatus(stopData);
    }
    if (this.isPickupStop()) {
      return this.populatePickupStopStatus();
    }
    return this.populateCompletedDeliveryStopStatus();
  };

  getPendingStopClasses = (pendingStopStatus) => {
    if (pendingStopStatus === appConstants.STOP_STATUS.DELAYED) {
      return this.getPendingStopWithDelayClasses();
    }
    return this.getPendingStopWithoutDelayClasses();
  };

  getStopWithReturnOrExceptionClasses = () => {
    const { classes } = this.props;
    return {
      title: classes.titleReturnOrException,
      subheader: classes.subheaderReturnOrException,
      avatar: classes.avatarReturnOrException,
      avatarColor: this.props.theme.ErrorMessageColor,
      statusWrapper: classes.statusWrapperReturnOrException,
      stopStatus: classes.stopStatusReturnOrException,
      priority: classes.priorityReturnOrException,
      statusTime: classes.statusTimeReturnOrException,
    };
  };

  getCompletedStopClasses = () => {
    const { classes } = this.props;
    return {
      title: classes.titleCompleted,
      subheader: classes.subheaderCompleted,
      avatar: classes.avatarCompleted,
      avatarColor: this.props.theme.completeStopText,
      statusWrapper: classes.statusWrapperCompleted,
      stopStatus: classes.stopStatusCompleted,
      priority: classes.priorityCompleted,
      statusTime: classes.statusTimeCompleted,
    };
  };

  getPendingStopWithoutDelayClasses = () => {
    const { classes } = this.props;
    return {
      title: classes.titlePending,
      subheader: classes.subheaderPending,
      avatar: classes.avatarPending,
      avatarColor: this.props.theme.ToggleIconColor,
      statusWrapper: classes.statusWrapperPending,
      stopStatus: classes.stopStatusPending,
      priority: classes.priorityPending,
      statusTime: classes.statusTimePending,
    };
  };

  getPendingStopWithDelayClasses = () => {
    return this.getStopWithReturnOrExceptionClasses();
  };

  getCompletedStopCustomClasses = (stopStatusObject) => {
    if (stopStatusObject.hasReturnOrExceptionBill) {
      return this.getStopWithReturnOrExceptionClasses();
    } else {
      return this.getCompletedStopClasses();
    }
  };

  isDriverArrivedAtStop = () => {
    const { routeData } = this.props;
    return routeData?.driverStatus === DRIVER_EVENTS.ArrivedAtStop;
  };

  getPendingStopArrivalTime = (stopStatusObject, stopData) => {
    return stopStatusObject === appConstants.STOP_STATUS.DELAYED
      ? `${stopData.plannedArrivalTime} (${appConstants.STOP_STATUS.DELAYED})`
      : stopData.plannedArrivalTime;
  };

  getCompletedStopArrivalTime = (stopData) => {
    return `${stopData.actualArrivalTime ?? ""} - ${
      stopData.actualDepartureTime ?? ""
    }`;
  };

  getCurrentStopTime = () => {
    const {routeData, stopData} = this.props;
    const arrivalTime = getStopArrivalTime(
      routeData?.currentStatus.status,
      stopData
    );
    return `${arrivalTime} ${
      hasStopDelayed(stopData)
        ? `(${appConstants.STOP_STATUS.DELAYED})`
        : ""
    }`;
  }

  renderArrivalTime = (stopStatusObject) => {
    const { stopData, isDriverCurrentStop } = this.props;
    if (!isDriverCurrentStop) {
      return this.isStopCompleted()
        ? this.getCompletedStopArrivalTime(stopData)
        : this.getPendingStopArrivalTime(stopStatusObject, stopData);
    }
    return this.getCurrentStopTime();
  };

  getDriverStatusDetails = () => {
    const { routeData, stopData } = this.props;
    return {
      stopStatusObject: null,
      customClasses: hasStopDelayed(stopData)
        ? this.getPendingStopWithDelayClasses()
        : this.getPendingStopWithoutDelayClasses(),
      overallStopStatus: `${
        SHOW_DRIVER_EVENTS[routeData?.currentStatus.status]
      } Stop`,
      stopStatusCode: "",
    };
  };

  getStopStatusDetails = () => {
    const stopStatus = this.getStopStatus();
    return {
      stopStatusObject: stopStatus,
      customClasses: this.isStopCompleted()
        ? this.getCompletedStopCustomClasses(stopStatus)
        : this.getPendingStopClasses(stopStatus),
      overallStopStatus: this.isStopCompleted()
        ? stopStatus?.overallStopStatus ?? ""
        : "ETA",
      stopStatusCode: stopStatus?.stopStatusCode ?? "",
    };
  };

  getStopProps = () => {
    const { isDriverCurrentStop } = this.props;
    if (!isDriverCurrentStop) {
      return this.getStopStatusDetails();
    }
    return this.getDriverStatusDetails();
  };

  onLockChange = () => {
    const { stopSequence, isLocked, isStopCompleted } = this.props.stopData;

    const stopCompleted = isLocked || isStopCompleted;
    this.props.onLockChanged(stopSequence, !stopCompleted);
  };

  markAsNextStop = () => {
    this.handleMenuClose();
    this.props.updateNextStop?.(this.props.stopData);
  };


  renderCardActions = () => {
    const { stopData, stopData: {isStopCompleted}, geofenceWindow} = this.props;
    const isLocked = isStopLocked(
      stopData,
      this.props.routeData.currentStatus
    );
    const isCardMenuExpandable = this.isCardMenuExpandable();
    const isMarkAsNextStopEnabled = this.isMarkAsNextStopEnabled();
    const { classes, resequenceMode, enableDispatchRouteResequence } =
      this.props;
    const lockIconTooltip = isLocked ? lockedText : unLockedText;
    const lockIcon = isLocked ? (
      <i className={appConstants.routeLockStates.LOCK.icon} />
    ) : (
      <i className={appConstants.routeLockStates.PARTIAL_LOCK.icon} />
    );
    const isBobTailRoute = this.props.routeData.trailerNumber === dispatchPanelConstants.TRAILER_NUMBER_FOR_BOBTAIL;
    const enableRevisitDeliveryOption = this.props.enableRevisitDeliveryStop && this.isCompletedReturnDelivery();
    const isDisableActionForPreDispatch = shouldDisableActionForPreDispatch(this.props.routeData, this.props.configJSON.enablePreDispatch);
    return (
      <div>
        {enableDispatchRouteResequence ? (
          <IconButton
            aria-label="Lock"
            classes={{ root: classes.lockIcon, disabled: classes.disableIcon }}
            onClick={this.onLockChange}
            disabled={
              !resequenceMode ||
              isStopLockedPermanently(
                stopData,
                this.props.routeData.currentStatus
              )
            }
          >
            <Tooltip title={lockIconTooltip} placement="bottom-start">
              {lockIcon}
            </Tooltip>
          </IconButton>
        ) : null}
        {geofenceWindow.geoFenceArrivalTime ? (
          <IconButton
            aria-label="edit"
            disabled={!isCardMenuExpandable}
            className={`${classes.editIcon} ${classes.driverPopupCardHeaderIcon}`}>
              <GeofenceToolTip enterTime={geofenceWindow.geoFenceArrivalTime} exitTime={geofenceWindow.geoFenceDepartureTime} />
          </IconButton>
        ) : null}
        {!this.props.disableActions &&
          <IconButton
            aria-label="edit"
            disabled={!isCardMenuExpandable}
            className={`${classes.editIcon} ${classes.driverPopupCardHeaderIcon} ${isCardMenuExpandable ? classes.enableIcon : classes.disableIcon
              }`}
            onClick={this.handleMenuOpen}
          >
            <Tooltip
              title={
                isStopCompleted
                  ? "Stop already completed"
                  : "Select stop to update"
              }
            >
              <MoreVert />
            </Tooltip>
          </IconButton>
        }
        <StopActionMenu
          handleMenuClose={this.handleMenuClose}
          anchorEl={this.state.anchorEl}
          handleMenuChange={this.handleMenuChange}
          isPickupStop={this.isPickupStop()}
          isMarkAsNextStopEnabled={isMarkAsNextStopEnabled}
          enableRemovePro={this.props.enableRemovePro}
          enableAddNotesToPro={this.props.enableAddNotesToPro}
          enableAddProToCompletedPro={this.props.enableAddProToCompletedPro}
          enableReprocessDelivery={this.props.enableReprocessDelivery}
          enableRevisitDeliveryStop={enableRevisitDeliveryOption}
          isCompletedStop={this.isStopCompleted()}
          isNoFreight={stopData.isNoFreight}
          isBobTailRoute={isBobTailRoute}
          isStopAlreadyRevisited={stopData.isStopAlreadyRevisited}
          isSplitStop={stopData.isSplitStop}
          shouldDisableActionForPreDispatch={isDisableActionForPreDispatch}
        />
      </div>
    );
  };

  toggleStopSequenceModel = (event) => {
    event.persist();
    this.setState({
      stopSequenceAnchorEl: this.state.stopSequenceAnchorEl
        ? null
        : event.currentTarget,
    });
  };

  getStatusCodesTooltip = () => {
    return formatShipmentsStatusCodesForTooltip(
      this.props.stopData?.shipments,
      this.props.DispatchStore,
      this.props.configJSON?.enableReturnExceptionReasonLabels
    );
  };

  isResunaDeliveryStop = (stopData) => {
    if (stopData.stopType === appConstants.STOP_TYPE.Delivery && stopData.shipments?.length) {
      return isDeliveryStopHasResunaPro(stopData.shipments, stopData.stopType);
    }
    return false;
  }
 
  getStopCodShipmentsData = (stopShipments) => {
    if (isStopHasCodShipments(stopShipments)) {
      const { codAmount, freightAmount } = stopShipments.reduce(
        (acc, shipment) => {
          acc.codAmount += shipment.codAmount || 0;
          acc.freightAmount += shipment.freightAmount || 0;
          return acc;
        },
        { codAmount: 0, freightAmount: 0 }
      );
      if (codAmount || freightAmount) {
        let tooltip = 'Shipment(s) has';
        if (codAmount) tooltip += ` COD Charge $${codAmount.toFixed(2)}`;
        if (freightAmount) tooltip += `${codAmount ? ' and' : ''} Freight Charge $${freightAmount.toFixed(2)}`;
        return { tooltip, stopHasCodShipments: true };
      }
      return { tooltip: '', stopHasCodShipments: false };
    }
    return { tooltip: '', stopHasCodShipments: false };
  };
  

  render() {
    const { classes, stopData, routeData, terminalCode, theme, geofenceWindow } = this.props;
    const isDriverArrived =  this.isDriverArrivedAtCurrentStop()
    const serviceLevelList = this.props.DispatchStore?.priorityAllShipmentList;
    const priority =
      getDisplayServiceLevels(stopData.priority, serviceLevelList).join(",") || "";
    const {
      stopStatusObject,
      customClasses,
      overallStopStatus,
      stopStatusCode,
    } = this.getStopProps();
    const { action, stopSequenceAnchorEl } = this.state;
    const isPickupStop = this.isPickupStop();
    const isUAPickup = isPickupStopUnAcknowledged(this.props.stopData);
    const stopHasExcessiveLength = isShipmentsHasExcessiveLength(stopData.shipments, stopData.stopType);
    const isResunaDeliveryStop = this.isResunaDeliveryStop(stopData);
    const stopCodShipmentData = this.getStopCodShipmentsData(stopData.shipments);
    const stopAddress = formatAddress({
      address: stopData?.address,
      address2: stopData?.address2,
      city: stopData?.city,
      state: stopData?.state,
      zip: stopData?.zip,
    })
    const stopTime= stopData.arrivalTime ? this.renderArrivalTime(stopStatusObject): "";
    const unattendedStop = isUnattendedStop(stopData)
    const statusCodesTooltip = this.getStatusCodesTooltip();
    const renderWithTooltip = (content, tooltip) =>
      tooltip ? <StyledToolTipWithScroll title={tooltip}>{content}</StyledToolTipWithScroll> : content;
    return (
      <Card className={classes.card}>
        <CardHeader
          classes={{
            title: customClasses.title,
            subheader: customClasses.subheader,
            root: classes.headerRoot,
          }}
          avatar={
            <Avatar
              aria-label="stopNo"
              className={`${customClasses.avatar} ${
                isPickupStop ? classes.pickupStopAvatar : ""
              }`}
            >
              {`${stopData.stopSequence}${isPickupStop ? "P" : "D"}`}
            </Avatar>
          }
          action={this.renderCardActions()}
          title={
            <StopCardTitle
              pickupIds={stopData.pickupIdList}
              pickupId={stopData.pickupId}
              title={
                <>
                  {stopData?.displayCustomerName}
                  <CustomerMergeIndicator displayCustomerName={stopData?.displayCustomerName} customerName={stopData?.name} />
                </>
              }
              unattendedStop={unattendedStop}
            />
          }
          subheader={
            <>
              {stopAddress}
              <div>
              {stopHasExcessiveLength && (
                <Tooltip key="excessiveLength" title="Excessive Length">
                  <div className={classes.excessiveLength}>
                    <ExcessiveLength
                      color = {theme.iconColor}
                    />
                  </div>
                </Tooltip>
              )}
              {isResunaDeliveryStop && (
                <Tooltip key="resuna" title="Residential Unattended Delivery">
                  <div className={classes.excessiveLength}>
                    <ResunaIcon
                      color = {theme.iconColor}
                    />
                  </div>
                </Tooltip>
              )}
              {stopCodShipmentData?.stopHasCodShipments && (
                  <Tooltip
                    key="cod"
                    title={stopCodShipmentData.tooltip}>
                    <div className={classes.excessiveLength}>
                      <DollarIcon color={theme.iconColor} />
                    </div>
                  </Tooltip>
                )}
              </div>
            </>
          }
        />
        <CardContent className={classes.noPadding}>
          <div className={customClasses.statusWrapper}>
            <div className={classes.status}>
              <div className={classes.statusContainer}>
                {stopData.isDriverChangedSequence && (
                  <Tooltip title="Driver updated the stop sequence">
                    <div className={classes.stopSequenceIcon}>
                      <IconButton
                        aria-label="stop-sequence-icon"
                        onClick={this.toggleStopSequenceModel}
                      >
                        <StopChangeSequence color={customClasses.avatarColor} />
                      </IconButton>
                    </div>
                  </Tooltip>
                )}
                <div id="status" className={customClasses.stopStatus}>
                  <div className={classes.stopStatusContainer}>
                    {isUAPickup ? (
                      <Tooltip title="Unacknowledged Pickup">
                        <p className={classes.uaIcon}>
                          <UnacknowledgedMarker
                            backgroundColor={theme.pickupStatusFillColors}
                            borderColor={theme.markerStokeColor}
                            size={18}
                          />
                        </p>
                      </Tooltip>
                    ) : null}
                    {stopData.unarrivedReason && (
                      <UnarriveIndicator
                        color={customClasses.avatarColor}
                        size={16}
                        unarrivedReason={stopData.unarrivedReason}
                        className={classes.unarrivedIcon}
                      />
                    )}
                    <div className={classes.overallStopStatusLine}>
                      {renderWithTooltip(
                        <span
                          id="overallStopStatus"
                          className={clsx(
                            customClasses.priority,
                            classes.overallStopStatusText
                          )}
                        >
                          {overallStopStatus}
                        </span>,
                        statusCodesTooltip
                      )}
                    </div>
                    {stopData.isStopCreatedFromRevisit && (
                      <Tooltip title="Revisit Stop">
                        <div className={classes.revisitIcon}>
                          <RevisitIcon color={customClasses.avatarColor} size={12} />
                        </div>
                      </Tooltip>
                    )}
                  </div>
                </div>
              </div>

              <div className={classes.statusCodeContainer}>
                {stopStatusCode && (
                  <StyledToolTipWithScroll title={statusCodesTooltip}>
                    <div className={classes.statusCode}>
                      <span
                        id="delStatusCode"
                        className={customClasses.priority}
                      >
                        {stopStatusCode}
                      </span>
                    </div>
                  </StyledToolTipWithScroll>
                )}
                {priority && (
                  <div
                    className={
                      stopData.arrivalTime ? classes.priorityContainer : null
                    }
                  >
                    <span id="priority" className={customClasses.priority}>
                      {priority}
                    </span>
                  </div>
                )}
                {stopData.arrivalTime && (
                  <div className={classes.arrivalTime}>
                    <span id="statusTime" className={customClasses.statusTime}>
                      {stopTime}
                    </span>
                  </div>
                )}
              </div>
              {!this.props.resequenceMode ? (
                <IconButton
                  className={clsx(classes.expand, {
                    [classes.expandOpen]: this.state.expanded,
                  })}
                  onClick={this.handleExpandClick}
                  aria-expanded={this.state.expanded}
                  aria-label="show more"
                >
                  <ExpandMoreIcon />
                </IconButton>
              ) : null}
            </div>
          </div>
        </CardContent>
        <Collapse
          in={!this.props.resequenceMode && this.state.expanded}
          timeout="auto"
          unmountOnExit
        >
          <CardContent
            classes={{
              root: classes.collapsibleDetailsRoot,
            }}
          >
            <CollapsibleDetails
              data={stopData}
              geofenceWindow={geofenceWindow}
              viewStopImages={this.props.viewStopImages}
              glEventHub={this.props.glEventHub}
              routeData={routeData}
              serviceLevelList={serviceLevelList}
            />
          </CardContent>
        </Collapse>
        {action === constants.STOPS_MENU_ACTION_LIST.PROCESS_DELIVERY && (
          <ProcessDeliveryDialog
            open={true}
            isDriverArrived={isDriverArrived}
            handleClose={this.handleClose}
            stopData={stopData}
            routeData={routeData}
            glEventHub={this.props.glEventHub}
          />
        )}
        {action === constants.STOPS_MENU_ACTION_LIST.PROCESS_PICKUP && (
          <ProcessPickupStopDialog
            open={true}
            isDriverArrived={isDriverArrived}
            handleClose={this.handleClose}
            stopData={stopData}
            routeData={routeData}
            glEventHub={this.props.glEventHub}
          />
        )}
        {action === constants.STOPS_MENU_ACTION_LIST.ADD_PRO_TO_PICKUP && (
          <ProcessPickupStopDialog
            open
            isDriverArrived={isDriverArrived}
            handleClose={this.handleClose}
            stopData={stopData}
            routeData={routeData}
            glEventHub={this.props.glEventHub}
            isReadOnly
            isAddProToCompletedPickupFlow
          />
        )}
        {action === constants.STOPS_MENU_ACTION_LIST.REMOVE_PRO && (
          <RemoveProDialog
            open={true}
            handleClose={this.handleClose}
            stopData={stopData}
            routeData={routeData}
          />
        )}
        {stopSequenceAnchorEl && (
          <StopSequenceHistory
            terminalCode={terminalCode}
            routeId={routeData.routeId}
            stopId={stopData.stopId}
            closeModel={this.toggleStopSequenceModel}
            stopSequenceAnchorEl={stopSequenceAnchorEl}
          />
        )}
        {action === constants.STOPS_MENU_ACTION_LIST.ADD_PRO_NOTES && (
          <ProNotes
            open
            title="Add Notes to Pro"
            handleClose={this.handleClose}
            stopDetails={{
              shipments: stopData.shipments,
              stopName: (
                <span className={classes.mergeNameWrap}>
                  {stopData?.displayCustomerName}
                  <CustomerMergeIndicator displayCustomerName={stopData?.displayCustomerName} customerName={stopData?.name} />
                </span>
              ),
              stopStatus: overallStopStatus,
              stopAddress,
              isPickupStop,
              stopTime
            }}
            terminalCode={terminalCode}
            driverId={this.props.driverId}
          />
        )}
        {action === constants.STOPS_MENU_ACTION_LIST.REVISIT_STOP && (
          <RevisitStopConfirmationPopup
            open
            handleClose={this.handleClose}
            {...this.props}
          />
        )}
      </Card>
    );
  }
}

export default compose(
  inject("DispatchStore"),
  withAppConfig,
  withStyles(styles),
  withSnackbar
)(Cards);
